import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { MAnalyticGlobalSearchParams, MAnalyticGlobalSearchResponse } from '@/modern/modules/m-analytics-module/services/types/analytics'

type ApiAnalyticGlobalSearchResponse = Promise<AxiosResponse<MAnalyticGlobalSearchResponse>>

export function globalSearch(params: MAnalyticGlobalSearchParams): ApiAnalyticGlobalSearchResponse {
    return http.get('/analytics/api/global-search', { params })
}

export default {
    globalSearch,
}
